/**
 * Central API Client for Hayat Family
 * Uses fetch with credentials: 'include' for cookie-based auth
 */

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
const WS_BASE_URL = process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:8001';

console.log('🔧 API Client initialized (v2 - no clone):', { API_BASE_URL, WS_BASE_URL });

/**
 * Make API request with automatic cookie handling
 * @param {string} path - API path (e.g., '/api/family/login')
 * @param {RequestInit} options - Fetch options
 * @returns {Promise<Response>}
 */
export async function apiFetch(path, options = {}) {
  const url = `${API_BASE_URL}${path}`;
  
  const response = await fetch(url, {
    credentials: 'include', // CRITICAL: Send cookies
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  return response;
}

/**
 * Make API request and parse JSON
 * @param {string} path
 * @param {RequestInit} options
 * @returns {Promise<any>}
 */
export async function apiFetchJSON(path, options = {}) {
  const response = await apiFetch(path, options);
  
  // CRITICAL: Read response text once to avoid "body already used" error
  const responseText = await response.text();
  
  let data;
  try {
    data = JSON.parse(responseText);
  } catch (e) {
    data = { detail: 'Failed to parse server response' };
  }
  
  if (!response.ok) {
    throw new Error(data.detail || `HTTP ${response.status}`);
  }
  
  return data;
}

/**
 * Get WebSocket URL
 */
export function getWebSocketURL(path) {
  return `${WS_BASE_URL}${path}`;
}

export { API_BASE_URL, WS_BASE_URL };
